import getRouteTransferType from "@Route/features/transportType/functions/getRouteTransferType";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";

export const isMinivanRoute = (routeTransferType: RouteTransferTypeKeys) => {
    const transferType = getRouteTransferType(routeTransferType)

    return transferType === 'minivan' || transferType === 'privateMinivan'
}